const point = "https://backend.bookify.kz"
const mediahost = "https://backend.bookify.kz"
const startpoint = `${point}/api/web2/`
const mediapoint = `${mediahost}/`

/* Short link service — a share link is built as <shareLink>/g/<url of the point> */
const shareLink = "https://i.bookify.kz"

/* Map provider — switch between "yandex" and "2gis" here */
const mapProvider = "yandex"

/* API keys for each provider */
const mapYandexKey = "d6ebf045-061a-42a2-81d5-ea1b88ba8790"
const map2gisKey = "YOUR_2GIS_MAPGL_KEY"

/* Yandex.Metrika counter id — must match the id in public/index.html */
const yandexMetrikaId = 109415065

export { startpoint, mediapoint, point, shareLink, mapProvider, mapYandexKey, map2gisKey, yandexMetrikaId }
